// TODO #1024 add all packages
enum PACKAGES {
  Api = 'ulams/api',
  AssignWithoutAccount = 'ulams/assign-without-account',
  Auth = 'ulams/auth',
  BookmarksNotes = 'ulams/bookmarks_notes',
  Cart = 'ulams/cart',
  Categories = 'ulams/categories',
  Cmi5 = 'ulams/cmi5',
  CompetencyChallenges = 'ulams/competency-challenges',
  ConsultationAccess = 'ulams/consultation-access',
  Consultations = 'ulams/consultations',
  Core = 'ulams/core',
  CourseAccess = 'ulams/course-access',
  Courses = 'ulams/courses',
  CoursesImportExport = 'ulams/courses-import-export',
  CsvUsers = 'ulams/csv-users',
  Files = 'ulams/files',
  H5P = 'ulams/h5p',
  Images = 'ulams/images',
  Invoices = 'ulams/invoices',
  Jitsi = 'ulams/jitsi',
  Lrs = 'ulams/lrs',
  Mailerlite = 'ulams/mailerlite',
  Mattermost = 'ulams/mattermost',
  ModelFields = 'ulams/model-fields',
  Notifications = 'ulams/notifications',
  Pages = 'ulams/pages',
  Payments = 'ulams/payments',
  PCGAttendances = 'ulams/pcg-attendances',
  PCGGrades = 'ulams/pcg-grades',
  PCGIntegration = 'ulams/pcg-integration',
  PencilSpaces = 'ulams/pencil-spaces',
  Permissions = 'ulams/permissions',
  Questionnaire = 'ulams/questionnaire',
  Reports = 'ulams/reports',
  Scorm = 'ulams/scorm',
  Settings = 'ulams/settings',
  StationaryEvents = 'ulams/stationary-events',
  Tags = 'ulams/tags',
  Tasks = 'ulams/tasks',
  Templates = 'ulams/templates',
  TemplatesEmail = 'ulams/templates-email',
  TemplatesPdf = 'ulams/templates-pdf',
  TemplatesSms = 'ulams/templates-sms',
  TopicTypeGift = 'ulams/topic-type-gift',
  TopicTypeProject = 'ulams/topic-type-project',
  TopicTypes = 'ulams/topic-types',
  Translations = 'ulams/translations',
  Video = 'ulams/video',
  Vouchers = 'ulams/vouchers',
  Webinar = 'ulams/webinar',
  Youtube = 'ulams/youtube',
  Dictionary = 'ulams/dictionaries',
  RevenuecatIntegration = 'ulams/revenuecat-integration',
}

export default PACKAGES;
